<div class="u-layout-relative">
  <div class="c-datepicker u-width-100" (click)="toggleCalendar($event)">
    <input
      type="text"
      name="daterange"
      id="daterange"
      readonly="true"
      [ngModel]="formatDateRange(providedDateRange)"
    />
    <i class="fa fa-calendar"></i>
  </div>
  <div
    class="daterangepicker show-calendar"
    *ngIf="showCalendar"
    [class.left]="alignLeft || position === 'left'"
    [class.right]="alignRight || position === 'right'"
  >
    <div class="daterangepicker__content">
      <div class="calendar left">
        <div class="daterangepicker_input">
          <input
            class="input-mini form-control active"
            type="text"
            name="daterangepicker_start"
            [ngModel]="selectedDateRange.start | amDateFormat: 'L LT'"
          />
          <i class="fa fa-calendar-o" aria-hidden="true"></i>
          <div class="calendar-time">
            <select
              class="hourselect"
              [(ngModel)]="startTime.hour"
              (ngModelChange)="updateTime('start')"
            >
              <option *ngFor="let hour of hours" [ngValue]="hour">{{
                hour | padNumber
              }}</option>
            </select>
            :
            <select
              class="minuteselect"
              [(ngModel)]="startTime.minute"
              (ngModelChange)="updateTime('start')"
            >
              <option *ngFor="let minute of minutes" [ngValue]="minute">{{
                minute | padNumber
              }}</option>
            </select>
            <select
              class="ampmselect"
              *ngIf="meridianNotation()"
              [(ngModel)]="startTime.meridian"
              (ngModelChange)="updateTime('start')"
            >
              <option value="AM">AM</option>
              <option value="PM">PM</option>
            </select>
            <i class="fa fa-clock-o glyphicon glyphicon-time"></i>
          </div>
        </div>
        <ls-calendar
          [range]="selectedDateRange"
          (dateSelected)="calendarDateSelected($event)"
          [max]="selectedDateRange.end"
          [month]="currentMonthStart"
        ></ls-calendar>
      </div>
      <div class="calendar right">
        <div class="daterangepicker_input">
          <input
            class="input-mini form-control"
            type="text"
            name="daterangepicker_end"
            [ngModel]="selectedDateRange.end | amDateFormat: 'L LT'"
          />
          <i class="fa fa-calendar-o" aria-hidden="true"></i>
          <div class="calendar-time">
            <div>
              <select
                class="hourselect"
                [(ngModel)]="endTime.hour"
                (ngModelChange)="updateTime('end')"
              >
                <option *ngFor="let hour of hours" [ngValue]="hour">{{
                  hour | padNumber
                }}</option>
              </select>
              :
              <select
                class="minuteselect"
                [(ngModel)]="endTime.minute"
                (ngModelChange)="updateTime('end')"
              >
                <option *ngFor="let minute of minutes" [ngValue]="minute">{{
                  minute | padNumber
                }}</option>
              </select>
              <select
                class="ampmselect"
                *ngIf="meridianNotation()"
                [(ngModel)]="endTime.meridian"
                (ngModelChange)="updateTime('end')"
              >
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
            <i class="fa fa-clock-o glyphicon glyphicon-time"></i>
          </div>
        </div>
        <ls-calendar
          [range]="selectedDateRange"
          (dateSelected)="calendarDateSelected($event)"
          [min]="selectedDateRange.start"
          [month]="currentMonthEnd"
        ></ls-calendar>
      </div>
    </div>
    <ul class="o-list o-list--inline daterangepicker__ranges">
      <li
        *ngFor="let shortcutRange of ranges"
        (click)="applyShortcutRange(shortcutRange.range)"
      >
        {{ shortcutRange.label }}
      </li>
    </ul>
    <div class="daterangepicker__footer">
      <button
        class="cancelBtn o-button o-button--small o-button--default"
        type="button"
        (click)="toggleCalendar($event, true)"
        i18n="Button|Button when you want to apply some changes @@buttonCancel"
      >
        Cancel
      </button>
      <button
        class="applyBtn o-button o-button--small o-button--success"
        type="button"
        (click)="toggleCalendar($event)"
        i18n="Button|Button when you want to apply some changes @@buttonApply"
      >
        Apply
      </button>
    </div>
  </div>
</div>
